export const generatePassword = () => {
  const combinations =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890!@#$%^&*()_+=-";

  let password = [];

  for (let i = 0; i <= 8; i++) {
    password[i] = combinations[Math.floor(Math.random() * combinations.length)];
  }

  return password.join("");
};
